import React from "react";
import { useNavigate } from "react-router-dom";
import { ListItemIcon, MenuItem } from "@mui/material";

const AccountMenuLink = ({
  icon,
  label,
  path,
  onLinkClicked,
}) => {
  const navigate = useNavigate();
  return (
    <MenuItem onClick={() => {
      onLinkClicked();
      navigate(path);
    }}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      {label}
    </MenuItem>
  );
};

export default AccountMenuLink;